import { Pipe, PipeTransform } from '@angular/core';
import { InstallerResponse, MatchedInstaller } from '../../domains/work/matched-installer/matched-installer.model';

@Pipe({ name: 'hasDeclinedWorkOrder' })
export class HasDeclinedWorkOrderPipe implements PipeTransform {
  transform(matchedInstaller: MatchedInstaller): boolean {
    return matchedInstaller?.response === InstallerResponse.Declined;
  }
}
